import { Component } from '@angular/core';
import { PillarPagesTemp } from '../../components/pillar-pages-temp/pillar-pages-temp';

@Component({
  selector: 'app-financial-services',
  imports: [PillarPagesTemp],
  templateUrl: './financial-services.html',
  styleUrl: './financial-services.scss',
})
export class FinancialServices {

}
